

















import {Component, Vue, Prop, Mixins, Watch} from 'vue-property-decorator';
import NiceCheckbox from "./NiceCheckbox.vue";
import {Mixin} from "@/mixins";
import store from "@/store";

@Component({
    components: {
        NiceCheckbox
    },
    name: "Voucher",
})
export default class Voucher extends Mixins(Mixin) {
    opened = false;

    voucher = '';

    store = store();

    mounted() {
        this.voucher = typeof this.store.serverData.additionalOptions.voucher.code !== 'undefined'
            ? this.store.serverData.additionalOptions.voucher.code
            : '';
    }

    @Watch('store.serverData.errors.additionalOptions', {immediate: true, deep: true})
    onAdditionalOptionsChanged(): void {
        if (this.opened) {
            return;
        }

        if (this.store.serverData.errors.additionalOptions && this.store.serverData.errors.additionalOptions.voucher) {
            this.opened = true;
        }
    }

    toggle() {
        this.opened = !this.opened;

        if (this.opened && !this.store.hasError('additionalOptions.voucher')) {
            this.voucher = this.store.serverData.additionalOptions.voucher.code!;
        }
    }

    onVoucherChange() {
        this.store.removeError('additionalOptions.voucher')
    }
}
